var A2E_DATA_TESTIDS = {
  container: "mntl-a2e-container",
  readViewContainer: "mntl-a2e-read-view-container",
  writeViewContainer: "mntl-a2e-write-view-container",
  validationContainer: "mntl-a2e-validation-container",
  microToastContainer: "mntl-a2e-micro-toast-container"
};

export { A2E_DATA_TESTIDS };
